import { toast } from "react-toastify";

import {
  SetDuplicateProductsRequestBodyType,
  SetDuplicateProductsResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const setDuplicateProductStatus = async (
  payload: ApiRequest<SetDuplicateProductsRequestBodyType>
) => {
  const resp = await api.post<
    SetDuplicateProductsResponseBodyType,
    SetDuplicateProductsRequestBodyType
  >(`/v2/duplicate-products/set-status`, payload.body);
  return resp.data;
};
export const useSetDuplicateProductStatus = () => {
  return useMutation<
    SetDuplicateProductsResponseBodyType,
    Error,
    ApiRequest<SetDuplicateProductsRequestBodyType>
  >({
    mutationFn: async (payload) => setDuplicateProductStatus(payload),
    onSuccess: (data, payload) => {
      if (payload.body.delayHours) {
        toast.success(`Duplicates will be archived in 48 hours`);
      } else {
        toast.success(`Duplicates Archiving`);
      }
    },
  });
};
